export const SET_STATISTICS = 'SET_STATISTICS'
export const SET_SEARCH_RANGE = 'SET_SEARCH_RANGE'
export const SET_UNIT = 'SET_UNIT'
export const SET_STORE_HOT_SALE = 'SET_STORE_HOT_SALE'
export const SET_STORE_HOT_SALE_REPORT_DATA = 'SET_STORE_HOT_SALE_REPORT_DATA'
export const CLEAR_STORE_HOT_SALE_REPORT_DATA = 'CLEAR_STORE_HOT_SALE_REPORT_DATA'
